import angular from "angular";

angular
	.module('app')
	.component('moderatorBindDetailModal', {
		template: require('./moderator-bind-detail-modal.html'),
        controller: ['$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http) {

	let $ctrl = this;

	$ctrl.step = 1;
    $ctrl.page = 1;
    $ctrl.perPage = '10';

    $ctrl.category = null;
    $ctrl.search = null;

	$ctrl.loading = false;

	$ctrl.$onInit = function () {
	    $ctrl.categories = $ctrl.resolve.categories;
	    $ctrl.otherDetailName = $ctrl.resolve.name;
        $ctrl.filter();
	};

    $ctrl.pageChanged = function () {
        $ctrl.filter();
    };

    $ctrl.filter = function () {
        $http.get('/details/filter', {
            params: {
                page: $ctrl.page,
                perPage: $ctrl.perPage,
                categoryId: $ctrl.category ? $ctrl.category.id : null,
                search: $ctrl.search,
            }
        }).then(function (response) {
            $ctrl.details = response.data.data;
            $ctrl.total = response.data.total;
        },function (error) {
            alert("Что-то пошло не так");
        });
    };

    $ctrl.reset =  function () {
        $ctrl.page = 1;
        $ctrl.search = null;
        $ctrl.category = null;
        $ctrl.filter();
    };

    $ctrl.selectDetail = (detail) => {
        if (!confirm('Вы действительно хотите выбрать эту деталь?')) {
            return;
        }
        $ctrl.step = 2;
        $ctrl.selectedDetail = detail;
    };

    $ctrl.confirm = () => {

        $ctrl.loading = true;

        let url = '/moderator/details/bind';

        $http
            .post(url, {
                other_detail_name: $ctrl.otherDetailName,
                detail_id: $ctrl.selectedDetail.id,
            })
            .then(
                () => {
                    $ctrl.loading = false;
                    window.Swal.fire({
                        icon: 'success',
                        title: 'Успешно добавлено',
                    }).then(function () {
                        window.location = '/moderator/others';
                    })
                }
            );
    };
}
